export default "__VITE_ASSET__D3nVl8FH__"